import { Action } from '../Action/index.js';
import * as React from 'react';
import { useContext } from 'react';
import { ThemeContext } from 'styled-components';
import { HeartOutlineIcon } from '../Icons/components/HeartOutline.js';
import { BankIcon } from '../Icons/components/Bank.js';
import { HappyFaceIcon } from '../Icons/components/HappyFace.js';
import { EmailIcon } from '../Icons/components/Email.js';
import { SignInIcon } from '../Icons/components/SignIn.js';

const AccountActions = ({ actionsProps , unreadMessages  })=>{
    const theme = useContext(ThemeContext);
    const { Wishlist , YourPayments , ReferralCode , ContactUs , SignIn  } = actionsProps;
    return /*#__PURE__*/ React.createElement(React.Fragment, null, Wishlist && !Wishlist.isHidden && /*#__PURE__*/ React.createElement(Action, {
        ...Wishlist,
        icon: /*#__PURE__*/ React.createElement(HeartOutlineIcon, {
            color: theme.colors.secondary,
            size: "24px"
        })
    }), YourPayments && !YourPayments.isHidden && /*#__PURE__*/ React.createElement(Action, {
        ...YourPayments,
        icon: /*#__PURE__*/ React.createElement(BankIcon, {
            color: theme.colors.secondary,
            size: "24px"
        })
    }), ReferralCode && !ReferralCode.isHidden && /*#__PURE__*/ React.createElement(Action, {
        ...ReferralCode,
        icon: /*#__PURE__*/ React.createElement(HappyFaceIcon, {
            color: theme.colors.secondary,
            size: "24px"
        })
    }), ContactUs && !ContactUs.isHidden && /*#__PURE__*/ React.createElement(Action, {
        ...ContactUs,
        icon: /*#__PURE__*/ React.createElement(EmailIcon, {
            color: theme.colors.secondary,
            size: "24px"
        }),
        textColor: unreadMessages > 0 ? theme.colors.secondary : undefined,
        descriptionColor: unreadMessages > 0 ? theme.colors.secondary : undefined,
        hasCircleBadge: unreadMessages > 0,
        circleBadgeText: unreadMessages,
        circleBadgeColor: theme.colors.negative,
        circleBadgeBorderColor: theme.colors.ElementBackground,
        circleBadgeTextColor: theme.colors.Background
    }), SignIn && !SignIn.isHidden && /*#__PURE__*/ React.createElement(Action, {
        ...SignIn,
        icon: /*#__PURE__*/ React.createElement(SignInIcon, {
            color: theme.colors.secondary,
            size: "24px"
        })
    }));
};

export { AccountActions };
